import {
  HISTORY_SEARCH_DEFAULTS,
  createHistoryRouterSearch,
  parseHistorySearch,
  type HistoryRouterSearch,
  type HistorySearchParams,
} from '@hooks/history/createHistoryRouterSearch';

export type OrderHistorySearchParams = HistorySearchParams;
export type OrderHistoryRouterSearch = HistoryRouterSearch;

export const ORDER_HISTORY_SEARCH_DEFAULTS: OrderHistorySearchParams = HISTORY_SEARCH_DEFAULTS;

export const parseOrderHistorySearch = parseHistorySearch;

export const useOrderHistoryRouterSearch = createHistoryRouterSearch('/orders/$id/history');
